<template>
    <div class="popup">
        <div class="popup-content" :class="{ 'is-loading': isLoading }">
            <button class="popup-close" @click.prevent="handleClosePopup"></button>

            <div class="popup-scrollable">
                <h2>Object toevoegen</h2>

                <form method="post" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">

                    <div class="alert alert-danger" v-if="error" v-text="error"></div>
                    <div class="alert alert-success" v-if="success" v-text="success"></div>
                    <div class="alert alert-warning" v-if="warning" v-text="warning" style="margin-bottom: 15px;"></div>

                    <div class="form-group" :class="{ 'is-invalid': form.errors.has('inspection_type') }" style="margin-top: 15px;">
                        <label class="form-label">Soort opname</label>
                        <ModelSelect :options="inspectionTypes" v-model="form.inspection_type"></ModelSelect>
                    </div>

                    <h3>Adresgegevens</h3>

                    <div class="row">
                        <div class="col-12 col-md-6" v-if="form.inspection_type === 1">
                            <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('zipcode') }">
                                <label class="form-label" for="zipcode">Postcode</label>
                                <input id="zipcode" class="form-control" type="text" v-model="form.zipcode" @blur="maybeFetchAddress">
                            </div>
                        </div>

                        <div class="col-12 col-md-3" v-if="form.inspection_type === 1">
                            <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('housenumber') }">
                                <label class="form-label" for="housenumber">Huisnummer</label>
                                <input id="housenumber" class="form-control" type="text" v-model="form.housenumber" @blur="maybeFetchAddress">
                            </div>
                        </div>

                        <div class="col-12 col-md-3" v-if="form.inspection_type === 1">
                            <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('housenumber_addition') }">
                                <label class="form-label" for="housenumber_addition">Toevoeging</label>
                                <input id="housenumber_addition" class="form-control" type="text" v-model="form.housenumber_addition" @blur="maybeFetchAddress">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div :class="{ 'col-12 col-md-4': form.inspection_type === 1, 'col-12 col-md-6': form.inspection_type !== 1 }">
                            <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('street') }">
                                <label class="form-label" for="street">Straat</label>
                                <input id="street" class="form-control" type="text" v-model="form.street" @input="lookupAddress" @change="lookupAddress">
                            </div>
                        </div>

                        <div :class="{ 'col-12 col-md-4': form.inspection_type === 1, 'col-12 col-md-6': form.inspection_type !== 1 }">
                            <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('city') }">
                                <label class="form-label" for="city">Plaats</label>
                                <input id="city" class="form-control" type="text" v-model="form.city">
                            </div>
                        </div>

                        <div class="col-12 col-md-4" v-if="form.inspection_type === 1">
                            <div class="form-group" :class="{ 'is-invalid': form.errors.has('country') }" style="margin-top: 15px;">
                                <label class="form-label">Land</label>
                                <ModelSelect :options="countries" v-model="form.country" placeholder="Selecteer een land" autocomplete="new-password"></ModelSelect>
                            </div>
                        </div>
                    </div>

                    <h3>Objectgegevens</h3>

                    <div class="row">
                        <div class="col-12 col-md-9" v-if="form.inspection_type === 1">
                            <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('type') }" style="margin-top: 15px;">
                                <label class="form-label">Type</label>
                                <ModelSelect :options="objectTypes" v-model="form.type" placeholder="Selecteer een type" autocomplete="new-password"></ModelSelect>
                            </div>
                        </div>

                        <div :class="{ 'col-12 col-md-3': form.inspection_type === 1, 'col-12': form.inspection_type !== 1 }">
                            <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('duration') }">
                                <label class="form-label" for="duration">Duur (minuten)</label>
                                <input id="duration" class="form-control" type="number" v-model="form.duration">
                            </div>
                        </div>
                    </div>

                    <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('description') }">
                        <label class="form-label" for="description">Omschrijving</label>
                        <textarea name="description" id="description" cols="30" rows="10" v-model="form.description"></textarea>
                    </div>

                    <h3>Planning</h3>

                    <ScheduleCreator v-model="form.schedule" :startDate="startDate"></ScheduleCreator>

                    <input type="submit" value="Object opslaan" class="btn btn-primary mt-2">
                </form>
            </div>
        </div>
    </div>
</template>

<script>
	import countries from '@/utilities/Countries'
	import { ModelSelect } from 'vue-search-select'
	import Form from '@/utilities/Form'
	import { FETCH_ALL_USERS } from '@/store/modules/users'
	import { FETCH_ADDRESS } from '@/store/modules/address'
	import { CREATE_OBJECT } from '@/store/modules/objects'
	import ObjectType from '@/utilities/mapping/ObjectType'
	import moment from 'moment'
	import ScheduleCreator from '@/components/global/ScheduleCreator'
	import { CREATE_SCHEDULE } from '../../store/modules/schedule'
	import { LOOKUP_ADDRESS } from '../../store/modules/address'

	export default {
		components: { ScheduleCreator, ModelSelect },

		props: ['project', 'startDate'],

		mounted () {
			this.fetchData()
		},

		data () {
			return {
				users: [],
				error: null,
				success: null,
                warning: null,
				isLoading: false,
				options: [],
				inspectionTypes: [
					{ value: 1, text: 'Interieur & exterieuropname' },
					{ value: 2, text: 'Infra opname' },
				],
				form: new Form({
					street: null,
					housenumber: null,
					housenumber_addition: null,
					zipcode: null,
					city: null,
					country: 'Nederland',
					type: null,
					duration: null,
					description: null,
					schedule: [],
					inspection_type: 1,
				}),
			}
		},

		computed: {
			countries () {
				return countries.map((country) => {
					return { value: country.name, text: country.name }
				})
			},

			objectTypes () {
				return ObjectType.map((type) => {
					return { value: type.text, text: type.text }
				})
			},

			getUsers () {
				let users = this.users.filter((user) => {
					if (user.roles.map((role) => {
						return role.name
					}).indexOf('Opname expert') >= 0) {
						return user
					}
				})

				return users.map((user) => {
					return { value: user.id, text: user.name }
				})
			},

			getStartDate () {
				return moment.utc(this.startDate).format('')
			},
		},

		methods: {
			maybeFetchAddress () {
				if (this.form.zipcode !== null && this.form.housenumber !== null) {
					let addition = {}

					if (this.form.housenumber_addition !== null && this.form.housenumber_addition.length !== 0) {
						addition.houseNumberAddition = this.form.housenumber_addition
					}

					this.$store.dispatch(FETCH_ADDRESS, Object.assign({}, addition, {
						postcode: this.form.zipcode.replace(' ', ''),
						houseNumber: this.form.housenumber,
					})).then((address) => {
						this.form.street = address.street
						this.form.city = address.city

						this.lookupAddress()
					})
				}
			},

			lookupAddress () {
				let addition = {}

				if (this.form.housenumber_addition !== null && this.form.housenumber_addition.length !== 0) {
					addition.houseNumberAddition = this.form.housenumber_addition
				}

				this.$store.dispatch(LOOKUP_ADDRESS, Object.assign({}, addition, {
					street: this.form.street,
					houseNumber: this.form.housenumber,
				})).then(() => {
					this.warning = 'Dit adres bestaat al in het systeem.'
				}).catch(() => {
					this.warning = '';
                })
			},

			onSelect (items) {
				this.form.inspectors = items
			},

			handleClosePopup () {
				this.$emit('togglePopup')
			},

			fetchData () {
				this.isLoading = true

				this.$store.dispatch(FETCH_ALL_USERS).then((data) => {
					this.isLoading = false
					this.users = data
				})
			},

			prepareFormData (formData) {
				let object = {}

				if (formData.housenumber_addition && formData.housenumber_addition.length > 0) {
					object.housenumber_addition = formData.housenumber_addition
				}

				if (formData.inspection_type === 1) {
					object.housenumber = formData.housenumber
					object.zipcode = formData.zipcode
					object.country = formData.country
					object.type = formData.type
				}

				return Object.assign({}, object, {
					inspection_type: formData.inspection_type,
					street: formData.street,
					city: formData.city,
					duration: formData.duration,
					description: formData.description,
				})
			},

			onSubmit () {
				this.isLoading = true

				this.$store.dispatch(CREATE_OBJECT, { project: this.project, data: this.prepareFormData(this.form) }).then((response) => {
					if (this.form.schedule.length > 0) {
						this.$store.dispatch(CREATE_SCHEDULE, {
							object: response.id,
							data: {
								data: this.form.schedule,
							},
						}).then(() => {
							location.reload()
							this.isLoading = false
							this.$emit('objectAdded')
						}).catch(() => {
							this.error = 'Er is een fout opgetreden. Controleer de velden en probeer het opnieuw.'
						})
					} else {
						this.isLoading = false
						this.$emit('objectAdded')
					}
				}).catch((response) => {
					if (response.errors) {
						this.form.errors.record(response.errors)
					} else {
						this.error = 'Er is een fout opgetreden. Controleer de velden en probeer het opnieuw.'
					}

					this.isLoading = false
				})
			},
		},
	}
</script>